import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../Loader/Loader";
import useApi from "../../hook/useApi";
import { toast } from "react-toastify";
import {
  copyToClipboard,
  formatDateInAMPM,
  trimAddress,
} from "../../utils/helper";
import "react-phone-input-2/lib/style.css";
import { IoCopyOutline } from "react-icons/io5";
import { STANDARD_IMAGE_URL } from "../../utils/constant";

const NftMarketplaceViewLayer = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const { id } = useParams();
  const { AsyncGetApiCall } = useApi();

  const fetchMarketplace = async () => {
    setLoading(true);
    try {
      const result = await AsyncGetApiCall(
        `/market-place/view-in-admin?id=${id}`
      );
      console.log("result: ", result);

      if (result.errors) {
        toast.error(result.errors[0]);
      } else if (result.success) {
        setData(result?.data);
      }
    } catch (error) {
      toast.error("An error occurred while fetching Marketplace details");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchMarketplace();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="row gy-4">
        {/* Left Card - NFT Image */}
        <div className="col-lg-4">
          <div className="card position-relative border radius-16 overflow-hidden bg-base h-100">
            <img
              src={data?.image ? data?.image : STANDARD_IMAGE_URL}
              alt="Marketplace"
              className="w-100 object-fit-cover"
              style={{ height: "100%", minHeight: "400px" }}
            />
          </div>
        </div>

        {/* Right Column */}
        <div className="col-lg-6">
          {/* Top Right Card - NFT Data */}
          <div className="card mb-10">
            <div className="card-body p-24">
              <h5 className="mb-16">Marketplace Details</h5>
              <ul>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Nft Id
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {trimAddress(data?.nftId?._id, 10, 8)}
                    <button
                      onClick={() => copyToClipboard(data?.nftId?._id)}
                      className="ms-3 p-0 border-0 bg-transparent"
                      style={{ lineHeight: 1 }}
                    >
                      <IoCopyOutline />
                    </button>
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Collection Address
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {trimAddress(data?.collectionAddress, 10, 8)}
                    <button
                      onClick={() => copyToClipboard(data?.collectionAddress)}
                      className="ms-3 p-0 border-0 bg-transparent"
                      style={{ lineHeight: 1 }}
                    >
                      <IoCopyOutline />
                    </button>
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Method
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {data?.method || "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Category
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {data?.category?.name || "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Created At
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {data?.createdAt
                      ? formatDateInAMPM(data?.createdAt)
                      : "N/A"}
                  </span>
                </li>
                {data?.method === "AUCTION" && (
                  <li className="d-flex align-items-center gap-2 mt-4">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      Start Time
                    </span>
                    <span>:</span>
                    <span className="w-70 text-secondary-light fw-medium">
                      {formatDateInAMPM(data?.auctionDetails?.startTime) ||
                        "N/A"}
                    </span>
                  </li>
                )}

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Expiry
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {data?.method === "FIXED"
                      ? data?.fixedDetails?.expiry
                        ? formatDateInAMPM(data?.fixedDetails?.expiry)
                        : "N/A"
                      : data?.auctionDetails?.endTime
                      ? formatDateInAMPM(data?.auctionDetails?.endTime)
                      : "N/A"}
                  </span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    listingId
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {data?.listingId || "N/A"}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NftMarketplaceViewLayer;
